import { MATCH_SPECIALIZATION_BOOST } from './constants'

export const centerProviderTypeMatchesLevelOfCare = (
  centerProviderType?: string | null,
  levelOfCare?: string
): number => {
  if (!centerProviderType || !levelOfCare) {
    return 0
  }

  return centerProviderType === levelOfCare ? MATCH_SPECIALIZATION_BOOST : 0
}
